import React from 'react';
import FormErrors from "./form_errors";
import {_t} from "../../../js/app/common/utils/locale";

export default class FormTextArea extends React.Component {

    render() {
        return (
            <div className="cluster__form-group">
                <label className={'label ' + (this.props.labelClass)} htmlFor={this.props.name}>{_t(this.props.label)}</label>
                <textarea
                    className={'form-control textarea ' + (this.props.errors ? 'is-invalid' : '')}
                    id={this.props.name}
                    name={this.props.name}
                    disabled={this.props.disabled}
                    placeholder={_t((this.props.placeholder ? this.props.placeholder : this.props.label))}
                    onChange={this.props.onChange}
                    defaultValue={this.props.value}
                />
                <FormErrors errors={this.props.errors} />
            </div>
        );
    }

}